import axios from 'axios';
import { useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import Lottie from 'react-lottie';
import { Link } from 'react-router-dom';
import { root_url } from '../setting';
import ScrollDownArrows from '../style/scroll-down-arrows.json';

const lottieOptions = {
  animationData: ScrollDownArrows,
  loop: true,
  autoplay: true,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice',
  },
};
const comment = {
  offline: '2025.10.19.(일) 오전 08:30 집결',
  apply_period: '2025.04.28.(월) 10:00 ~ 07.11.(금) 16:00',
  // course: `건강코스(5km) 1,000명, 미니코스(10km) 1,500명, 하프코스(21.0975km) 500명`,
  // numOfRunners: "건강코스 - 1,000명 / 미니코스 - 1,500명 / 하프코스 - 500명",
};

const showCurrentStatus = (ticketInfo) => {
  let isShow = false;
  for (let i = 0; i < ticketInfo.length; i++) {
    const now = new Date();
    const saleOpenTime = new Date(ticketInfo[i].saleOpenTime);
    const saleCloseTime = new Date(ticketInfo[i].saleCloseTime);

    if (saleOpenTime.getTime() < now.getTime() && now.getTime() < saleCloseTime.getTime()) {
      isShow = true;
      break;
    }
  }
  return isShow;
};

const MainJumbo = ({ scroll }) => {
  // console.log(scroll);
  const [ticketInfo, setTicketInfo] = useState([]);
  const getTicketInfo = async () => {
    try {
      let res = await axios.get(`${root_url}/api/ticket/sold`);
      console.log('get ticket info');
      const { data } = res;
      console.log(data);
      setTicketInfo(data);
    } catch (e) {
      console.log(e);
      return;
    }
  };
  useEffect(() => {
    getTicketInfo(); // 처음에 실행
    const interval = setInterval(getTicketInfo, 10000);
    return () => clearInterval(interval); // clean up on unmount
  }, []);
  return (
    <div
      className="text-center noselect text-white main-jumbo"
      style={{
        width: '100vw',
        backgroundImage: `linear-gradient(rgba(0,0,0,0.55), rgba(0,0,0,0.3)),url('/dcm_23.jpg')`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: '50% 70%',
        backgroundSize: 'cover',
      }}
    >
      {showCurrentStatus(ticketInfo) && (
        <div
          className="d-none d-xl-inline-block"
          style={{
            position: 'absolute',
            top: 70,
            right: 50,
            border: '1px solid white',
            padding: 20,
            borderRadius: 10,
          }}
        >
          <p>현재 접수 현황 - 입금기준</p>
          {ticketInfo?.map((ticket) =>
            ticket.total >= ticket.acceptable ? (
              <p>{ticket.ticketName} - 접수 마감</p>
            ) : (
              <p>
                {ticket.ticketName} - {ticket.total}/{ticket.acceptable}명
              </p>
            )
          )}
        </div>
      )}

      <h2
        className="animation-header"
        style={{
          paddingTop: '15vh',
          marginBottom: '5vh',
        }}
      >
        "마음가득 사랑담고 달리자"
      </h2>
      <h1 style={{ fontSize: '3.5rem', fontWeight: '500' }}>제24회 대청호마라톤대회</h1>
      <br />
      <div className="mb-4 d-none d-md-inline-block">
        <div
          className="rounded-pill d-inline-flex"
          style={{
            backgroundColor: 'rgba(255,255,255,0.2)',
            width: '40rem',
            // margin: margin,
          }}
        >
          <p
            className="mb-0 p-2 ps-4 pe-4 rounded-pill text-center bg-custom-color"
            style={{
              color: 'white',
              width: '10rem',
            }}
          >
            대회일시
          </p>
          <p className="mb-0 p-2 pe-4 ps-3">{comment.offline}</p>
        </div>
      </div>
      <br className="d-none d-md-block" />
      <div className="mb-4 d-none d-md-inline-block">
        <div
          className="rounded-pill d-inline-flex text-center"
          style={{
            backgroundColor: 'rgba(255,255,255,0.2)',
            width: '40rem',
            // margin: margin,
          }}
        >
          <p
            className="mb-0 p-2 ps-4 pe-4 rounded-pill text-center bg-custom-color"
            style={{
              color: 'white',
              width: '10rem',
            }}
          >
            접수기간
          </p>
          <p className="mb-0 p-2 pe-4 ps-3">{comment.apply_period}</p>
        </div>
      </div>
      <br className="d-none d-md-block" />
      <div className="mb-4 d-none d-md-inline-block">
        <div
          className="rounded-pill d-inline-flex"
          style={{
            backgroundColor: 'rgba(255,255,255,0.2)',
            width: '40rem',
            // margin: margin,
          }}
        >
          <p
            className="mb-0 p-2 ps-4 pe-4 rounded-pill bg-custom-color"
            style={{
              color: 'white',
              width: '10rem',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            운영종목
          </p>
          <p className="mb-0 p-2 pe-4 ps-3" style={{ textAlign: 'left' }}>
            건강코스(5km)
            <br />
            미니코스(10km)
            <br />
            하프코스(21.0975km)
          </p>
        </div>
      </div>
      <br className="d-none d-md-block" />
      <div className="mb-4 d-none d-md-inline-block">
        <div
          className="rounded-pill d-inline-flex"
          style={{
            backgroundColor: 'rgba(255,255,255,0.2)',
            width: '40rem',
            // margin: margin,
          }}
        >
          <p
            className="mb-0 p-2 ps-4 pe-4 rounded-pill text-center bg-custom-color"
            style={{
              color: 'white',
              width: '10rem',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            참가인원
          </p>
          <p className="mb-0 p-2 pe-4 ps-3" style={{ textAlign: 'left' }}>
            건강코스 - 1,000명
            <br />
            미니코스 - 1,500명
            <br />
            하프코스 - 1,000명
            <br />* 결제완료순
          </p>
        </div>
      </div>
      {/* only mobile */}
      <div className="d-block d-md-none">
        <p className="mb-0  ps-4 pe-4 rounded-pill text-center bg-custom-color d-inline-block w-75">
          대회일시
        </p>
        <p>{comment.offline}</p>
      </div>
      <div className="d-block d-md-none">
        <p className="mb-0 ps-4 pe-4 rounded-pill text-center bg-custom-color d-inline-block w-75">
          접수기간
        </p>
        <p>{comment.apply_period}</p>
      </div>
      <div className="d-block d-md-none">
        <p className="mb-0 ps-4 pe-4 rounded-pill text-center bg-custom-color d-inline-block w-75">
          운영종목
        </p>
        <p>
          건강코스(5km)
          <br />
          미니코스(10km)
          <br />
          하프코스(21.0975km)
        </p>
      </div>
      <div className="d-block d-md-none">
        <p className="mb-0 ps-4 pe-4 rounded-pill text-center bg-custom-color d-inline-block w-75">
          참가인원
        </p>
        <p>
          건강코스 - 1,000명
          <br />
          미니코스 - 1,500명
          <br />
          하프코스 - 1,000명
          <br />* 결제완료순
        </p>
      </div>
      <Row className="mt-5">
        <Col
          className="rounded-pill hover-bg-mod p-2 bg-custom-color mt-2"
          lg={{ span: 2, offset: 3 }}
          xs={{ span: 3, offset: 2 }}
        >
          <Link
            to="/apply/individual"
            style={{ color: 'white', display: 'block', fontSize: '1.1rem' }}
          >
            참가신청
          </Link>
        </Col>
        <Col
          className="rounded-pill hover-bg-mod p-2 bg-custom-color mt-2"
          lg={{ span: 2, offset: 2 }}
          xs={{ span: 3, offset: 2 }}
        >
          <Link to="/apply/search" style={{ color: 'white', display: 'block', fontSize: '1.1rem' }}>
            신청조회
          </Link>
        </Col>
      </Row>
      <Row className="mt-5 d-none d-xl-block">
        <Col className="p-2 cursor-pointer" xs={{ span: 4, offset: 4 }}>
          <a
            href="#courseSummary"
            style={{
              color: 'white',
              fontSize: '1.4rem',
              position: 'relative',
              top: '5rem',
            }}
          >
            코스 안내
          </a>
        </Col>
      </Row>
      <div className="d-none d-xl-block">
        <Lottie
          options={lottieOptions}
          isClickToPauseDisabled={true}
          style={{ width: '300px', height: '300px' }} // svg의 부모 div에 적용
        />
      </div>
      {/* <Container
        style={{
          border: "1px solid",
          borderRadius: "20px",
          opacity: "0.8",
          padding: "1rem",
        }}
        className="bg-primary mt-5"
      >
        <h3 className="mt-3">2022년 대청호 마라톤 대회 오픈 준비중입니다.</h3>
        <h3 className="mt-3">
          최대한 빠른 시간 내에 달리미들을 만나볼 수 있도록 노력하겠습니다.
        </h3>
        <h3 className="mt-3 mb-3">올해에도 많은 관심 부탁드립니다.</h3>
      </Container> */}
    </div>
  );
};
export default MainJumbo;
